import type { SVGProps } from 'react';

export default function Car(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 14C8.5 14.2761 8.27614 14.5 8 14.5C7.72386 14.5 7.5 14.2761 7.5 14C7.5 13.7239 7.72386 13.5 8 13.5C8.27614 13.5 8.5 13.7239 8.5 14Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 14C16.5 14.2761 16.2761 14.5 16 14.5C15.7239 14.5 15.5 14.2761 15.5 14C15.5 13.7239 15.7239 13.5 16 13.5C16.2761 13.5 16.5 13.7239 16.5 14Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 17.75V19.25M17.25 17.75V19.25M5.75 17.25H18.2502C18.8025 17.25 19.2502 16.8023 19.2502 16.25V12.75C19.2502 11.6454 18.3548 10.75 17.2502 10.75H6.75C5.64543 10.75 4.75 11.6454 4.75 12.75V16.25C4.75 16.8023 5.19772 17.25 5.75 17.25ZM5.75 10.75H18.2502L17.5288 6.4212C17.368 5.45683 16.5337 4.75 15.556 4.75H8.44425C7.46657 4.75 6.6322 5.45683 6.47147 6.4212L5.75 10.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
